export function readDeviceTimeZoneId(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

export function readLocalDateKey(value: Date, timeZoneId: string): string {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      day: '2-digit',
      month: '2-digit',
      timeZone: timeZoneId,
      year: 'numeric',
    }).formatToParts(value);
    const year = parts.find((part) => part.type === 'year')?.value;
    const month = parts.find((part) => part.type === 'month')?.value;
    const day = parts.find((part) => part.type === 'day')?.value;

    if (year && month && day) {
      return `${year}-${month}-${day}`;
    }
  } catch {
    // Fall back to UTC when the supplied IANA time zone is unavailable.
  }

  return value.toISOString().slice(0, 10);
}

export function millisecondsUntilNextLocalDay(now: Date, timeZoneId: string): number {
  const currentDate = readLocalDateKey(now, timeZoneId);
  let lowerBound = now.getTime();
  let upperBound = lowerBound + 48 * 60 * 60 * 1000;

  if (readLocalDateKey(new Date(upperBound), timeZoneId) === currentDate) {
    return 24 * 60 * 60 * 1000;
  }

  while (upperBound - lowerBound > 1000) {
    const midpoint = Math.floor((lowerBound + upperBound) / 2);
    if (readLocalDateKey(new Date(midpoint), timeZoneId) === currentDate) {
      lowerBound = midpoint;
    } else {
      upperBound = midpoint;
    }
  }

  return Math.max(1, upperBound - now.getTime() + 50);
}
